import { render, staticRenderFns } from "./BindsCardHeaderText.vue?vue&type=template&id=a1804a5e&"
import script from "./BindsCardHeaderText.vue?vue&type=script&lang=js&"
export * from "./BindsCardHeaderText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports